// components/web/MembershipStatusCard.jsx
import { Crown, ChevronRight } from "lucide-react";
import { formatINR } from "./VoucherCheckoutPanel";
import { getMembershipStatus } from "../../utils/membershipStatus";
const formatCardNumber = (n) => (n ? String(n).replace(/\s+/g, "").replace(/(.{4})/g, "$1 ").trim() : null);
const formatExpiry = (d) =>
    d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : null;

export default function MembershipStatusCard({ user, savingsThisMonth = 0, onView, onBuy }) {
    const { state, programName, activationDate, deactivationDate,cardNumber } = getMembershipStatus(user);
    const cardNo = formatCardNumber(cardNumber);

    if (state === "active") {
        const since = activationDate
            ? new Date(activationDate).toLocaleDateString("en-IN", { month: "short", year: "numeric" })
            : null;
        return (
            <button type="button" onClick={onView} className="block w-full rounded-2xl bg-gradient-to-br from-[#0B2E7A] to-[#0B67FC] p-4 text-left text-white shadow-sm">
                <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/15">
                        <Crown size={20} className="text-[#f4c542]" />
                    </span>
                    <div className="min-w-0 flex-1">
                        <p className="text-sm font-bold uppercase tracking-wide text-[#f4c542]">{programName}</p>
                        {since && <p className="text-xs text-white/80">Member since {since}</p>}
                    </div>
                </div>
                {savingsThisMonth > 0 && (
                    <>
                        <p className="mt-4 text-3xl font-bold">{formatINR(savingsThisMonth)}</p>
                        <p className="text-xs text-white/80">saved this month</p>
                    </>
                )}
                {(cardNo || deactivationDate) && (
    <div className="mt-4 flex items-end justify-between gap-3">
        {cardNo && (
            <div className="min-w-0">
                <p className="text-[10px] uppercase tracking-wider text-white/60">Card number</p>
                <p className="truncate font-mono text-sm tracking-widest">{cardNo}</p>
            </div>
        )}
        {deactivationDate && (
            <div className="shrink-0 text-right">
                <p className="text-[10px] uppercase tracking-wider text-white/60">Expires</p>
                <p className="text-sm font-semibold">{formatExpiry(deactivationDate)}</p>
            </div>
        )}
    </div>
)}
                <div className="mt-4 flex items-center justify-between border-t border-white/15 pt-3 text-sm font-semibold">
                    View membership <ChevronRight size={16} />
                </div>
            </button>
        );
    }

    if (state === "expired") {
        const until = deactivationDate
            ? new Date(deactivationDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
            : null;
        return (
            <button type="button" onClick={onBuy} className="block w-full rounded-2xl border border-amber-200 bg-amber-50 p-4 text-left shadow-sm">
                <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-100">
                        <Crown size={20} className="text-amber-600" />
                    </span>
                    <div className="min-w-0 flex-1">
                        <p className="text-sm font-bold text-amber-800">{programName} expired</p>
                        {until && <p className="text-xs text-amber-700">on {until}</p>}
                    </div>
                    <ChevronRight size={18} className="text-amber-500" />
                </div>
                <p className="mt-3 text-xs font-semibold text-amber-700">Renew now to keep earning better offers</p>
            {cardNo && <p className="mt-1 font-mono text-xs tracking-widest text-amber-700/80">{cardNo}</p>}
            </button>
        );
    }

    return ( // state === "none"
        <button type="button" onClick={onBuy} className="block w-full rounded-2xl border border-[#0B67FC]/20 bg-[#0B67FC]/5 p-4 text-left shadow-sm">
            <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#0B67FC]/10">
                    <Crown size={20} className="text-[#0B67FC]" />
                </span>
                <div className="min-w-0 flex-1">
                    <p className="text-sm font-bold text-gray-900">Get GoerOne Plus</p>
                    <p className="text-xs text-gray-600">Unlock better offers & rewards</p>
                </div>
                <ChevronRight size={18} className="text-[#0B67FC]" />
            </div>
        </button>
    );
}